import api from './api'

export default {
  list(planId) {
    return api.get(`/admin/plans/${planId}/integration-plans`)
  },
  create(planId, data) {
    return api.post(`/admin/plans/${planId}/integration-plans`, data)
  },

  update(planId, integrationPlanId, data) {
    return api.put(
      `/admin/plans/${planId}/integration-plans/${integrationPlanId}`,
      data,
    )
  },
}
